const routePrefix = '/ogp';

export { routePrefix };
